/* סינון ומיון של מסך הפעולות. פונקציות טהורות, בלי React */
import { fmt, absAmt, iso10 } from '../lib/format.js';
import { cat } from './categories.js';
import { getTxSrc, isExcluded } from './tx.js';
import { fixedNameSet, isFixedCharge } from './recurring.js';

/** מצב הסינון ההתחלתי. cats: מזהים בצורה "expense:food" */
export const txfDefault = () => ({ q: '', all: false, type: 'all', src: 'all', cats: [], uncat: false, hideFixed: false, sort: 'date' });

/** כמה מסננים פעילים (בלי המיון, שהוא רק סדר) */
export function txfCount(f) {
  return (f.q.trim() ? 1 : 0) + (f.all ? 1 : 0) + (f.type !== 'all' ? 1 : 0) + (f.src !== 'all' ? 1 : 0) + (f.cats.length ? 1 : 0) + (f.uncat ? 1 : 0) + (f.hideFixed ? 1 : 0);
}

export const catKey = (t) => (t.type === 'income' ? 'income' : 'expense') + ':' + (cat(t.type === 'income' ? 'income' : 'expense', t.cat).id || 'other');

/** חיפוש בשם, ובסכום עם או בלי פסיק ו-₪ */
export function matchQuery(t, q) {
  const ql = q.toLowerCase().trim();
  if (!ql) return true;
  if ((t.description || '').toLowerCase().includes(ql)) return true;
  const num = ql.replace(/[,₪\s]/g, '');
  return !!num && /^[\d.]+$/.test(num) && (String(Number(t.amount)).includes(num) || fmt(t.amount).replace(/[^\d.]/g, '').includes(num));
}

/**
 * @param list הפעולות לפני סינון (של התקופה, או של כל התקופות)
 * @param skip מסננים לדלג עליהם (למשל 'cats' כשסופרים כמה פעולות יש בכל קטגוריה)
 * @returns {{ txs: Array, hidden: { n: number, sum: number } }}
 */
export function applyTxFilter(list, f, skip = []) {
  const fixed = f.hideFixed && !skip.includes('hideFixed') ? fixedNameSet() : null;
  const cats = !skip.includes('cats') && f.cats.length ? new Set(f.cats) : null;
  const hidden = { n: 0, sum: 0 };
  const txs = list.filter((t) => {
    if (f.type !== 'all' && t.type !== f.type) return false;
    if (f.src !== 'all' && getTxSrc(t) !== f.src) return false;
    if (cats && !cats.has(catKey(t))) return false;
    if (f.uncat && !skip.includes('cats') && !(t.type !== 'income' && (cat('expense', t.cat).id || 'other') === 'other')) return false;
    if (!matchQuery(t, f.q)) return false;
    if (fixed && isFixedCharge(t, fixed)) {
      hidden.n++;
      if (t.type === 'expense' && !isExcluded(t)) hidden.sum += absAmt(t);
      return false;
    }
    return true;
  });
  // תאריך: החדש למעלה. סכום: הגדול למעלה, ובשוויון החדש קודם
  const byDate = (a, b) => (iso10(b.date) < iso10(a.date) ? -1 : iso10(b.date) > iso10(a.date) ? 1 : (b.id > a.id ? 1 : -1));
  txs.sort(f.sort === 'amount' ? (a, b) => absAmt(b) - absAmt(a) || byDate(a, b) : byDate);
  return { txs, hidden };
}
